// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1KbQc","signatureBlock":"Footer_signatureBlock__PTz6v","signature":"Footer_signature__2VPql"};